import ScrollSpy from '/src/scripts/es-modules/scrollspy';

new ScrollSpy();

document.addEventListener('DOMContentLoaded', () => {
  const sidenav = document.querySelector('.sidenav');

  document.addEventListener('click', (e) => {
    const el = e.target;

    if (window.innerWidth <= 1536) {
      if (!el.closest('.sidenav')) {
        sidenav.classList.remove('sidenav_open');
      }

      if (
        el.classList.contains('sidenav__link') ||
        el.classList.contains('sidenav__switch')
      ) {
        sidenav.classList.toggle('sidenav_open');
      }
    }
  });
});
